<template>
    <footer class="footer has-cards">
        <div class="container">
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2">Fale conosco</h3>
                    <h4 class="mb-0 font-weight-light">Quer fazer uma sugestão, crítica ou entrar em contato conosco? Fique a vontade, estamos disponíveis nestes canais de atendimento.</h4>
                </div>
                <div class="col-lg-6 text-lg-left btn-wrapper">
                    <h5>
                        Telefones: (88) 3511-5377 e (88) 3571-8934
                    </h5>
                    <h5>
                        E-mail: contato@jhmmartins.com.br
                    </h5>
                    <!-- <a target="_blank" rel="noopener" href="https://twitter.com/creativetim"
                       class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-twitter"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://www.facebook.com/creativetim"
                       class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Like us">
                        <i class="fa fa-facebook-square"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://dribbble.com/creativetim"
                       class="btn btn-neutral btn-icon-only btn-dribbble btn-lg btn-round" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-dribbble"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://github.com/creativetimofficial"
                       class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Star on Github">
                        <i class="fa fa-github"></i>
                    </a> -->
                </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    
                    <div class="copyright">
                        &copy; {{year}}
                        <a href="https://www.paguru.com.br" target="_blank" rel="noopener">Paguru</a>
                    </div>
                </div>
                <div class="col-md-6 text-right">
                    <img src="img/brand/jhm_transparente.png" class="w-75" />
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
